import React from 'react';
import {useEffect, useState} from 'react';
import { ReactComponent as Logo } from './img/books.svg';
import './styling/menu.css';

export const MenuBar = () => {
    useEffect(() => {
            let link1 = document.getElementById('one');
            let link3 = document.getElementById('three');
            let link4 = document.getElementById('four');
            if(50 < window.pageYOffset && window.pageYOffset < 201 && window.location.hash === ''){
                link4.classList.add('my');
                link1.classList.remove('my');
                link3.classList.remove('my');
            }else if(50 >= window.pageYOffset && window.location.hash === ''){
                link4.classList.remove('my');
                link1.classList.add('my');
                link3.classList.remove('my');
            }else if(window.pageYOffset >= 201 && window.location.hash === ''){
                link3.classList.add('my');
                link4.classList.remove('my');
                link1.classList.remove('my');
            }
            window.addEventListener('scroll', () => {
                if(50 < window.pageYOffset && window.pageYOffset < 201 && window.location.hash === ''){
                    link4.classList.add('my');
                    link1.classList.remove('my');
                    link3.classList.remove('my');
                }else if(50 >= window.pageYOffset && window.location.hash === ''){
                    link4.classList.remove('my');
                    link1.classList.add('my');
                    link3.classList.remove('my');
                }else if(window.pageYOffset >= 201 && window.location.hash === ''){
                    link3.classList.add('my');
                    link4.classList.remove('my');
                    link1.classList.remove('my');
                }
            });
    });
    const [close, setClose] = useState(<img src="https://img.icons8.com/android/24/000000/menu.png" alt="menu"/>);
    const openMenu = () => {
        let elem = document.getElementById('mobile');
        if(close === "×"){
            setClose(<img src="https://img.icons8.com/android/24/000000/menu.png" alt="menu"/>);
            elem.style.left = "-70%";
        }else {
            setClose("×");
            elem.style.left = "0%";
        }
    }
    return (
        <header>
            <button className="mobile-menu" onClick={() => openMenu()}>
            {close}
            </button>
            <MobileMenu/>
            <nav>
                <ul>
                    <li><a href="/" id="three">نتائج البحث</a></li>
                    <li><a href="/" id="four">البحث</a></li>
                    <li><a href="/" id="one">الرئيسية</a></li>
                </ul>
            </nav>
            <Logo/>
        </header>
    );
}

const MobileMenu = () => {
    return(
        <div className="mobile" id="mobile">
            <a href="/">نتائج البحث</a>
            <a href="/">البحث</a>
            <a href="/">الرئيسية</a>
        </div>
    )
}
